import apiClient from './client'
import type { SearchQuery, SearchResponse } from '@/types/models'

/**
 * Search API endpoints
 */
export const searchApi = {
  /**
   * Perform semantic search across feed items
   */
  async search(query: SearchQuery): Promise<SearchResponse> {
    return apiClient.get<SearchResponse>('/api/v1/search', {
      params: {
        q: query.q,
        feedId: query.feedId,
        limit: query.limit,
        offset: query.offset,
        ...query.filters,
      },
    })
  },

  /**
   * Get search suggestions based on partial query
   */
  async suggest(partialQuery: string): Promise<{ suggestions: string[] }> {
    return apiClient.get<{ suggestions: string[] }>('/api/v1/search/suggest', {
      params: { q: partialQuery },
    })
  },
}

export default searchApi
